module.exports = __webpack_public_path__ + "static/media/header-iron.36774929.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/themes/irontrade/header-iron.jpg
// module id = 1239
// module chunks = 103